import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";
import Select from "react-select";
import { smallFormSelectCustomStyles } from "../../../utils/SelectCustomStyles";
import logoInoxShipping from "../../../images/inox_logo.png";
import { format } from "date-fns";
import { downloadPDF } from "../../../utils/downloadPdf";



function PlannedExportDocuments(props) {
  const addconfirmationdocumentform = useRef(null);
  const [shipmentData, setShipmentData] = useState([]);
  const [shipmentDataPending, setShipmentDataPending] = useState(true);
  const [bookingConfirmationDocumentData, setBookingConfirmationDocumentData] = useState([]);
  const [bookingConfirmationDocumentDataPending, setBookingConfirmationDocumentDataPending] = useState(true);

  const shipment_id = props.shipmentId
  const agentList = props.agentList
  const depotList = props.depotList
  const currentUserRolePermissionData = props.currentUserRolePermissionData
  const loggedInUser = props.loggedInUser

  // ----------------------- CRO --------------------------------
  const [showAddBookingConfirmationDocumentModal, setShowAddBookingConfirmationDocumentModal] = useState(false);
  const [showUpdateBookingConfirmationDocumentModal, setShowUpdateBookingConfirmationDocumentModal] = useState(false);
  const [showDeleteBookingConfirmationDocumentModal, setShowDeleteBookingConfirmationDocumentModal] = useState(false);
  const [showIssueBookingConfirmationDocumentModal, setShowIssueBookingConfirmationDocumentModal] = useState(false);
  const [showCancelBookingConfirmationDocumentModal, setShowCancelBookingConfirmationDocumentModal] = useState(false);

  const [updateBookingConfirmationDocumentId, setUpdateBookingConfirmationDocumentId] = useState("");
  const [updateShipment, setUpdateShipment] = useState("");
  const [updateDocumentType, setUpdateDocumentType] = useState("");
  const [updateReferenceNumber, setUpdateReferenceNumber] = useState("");
  const [updateIssuedBy, setUpdateIssuedBy] = useState("");
  const [updateIssueDate, setUpdateIssueDate] = useState("");
  const [updateContainer, setUpdateContainer] = useState("");
  const [updateBookingParty, setUpdateBookingParty] = useState("");
  const [updatePickDepot, setUpdatePickDepot] = useState("");
  const [updateDropDepot, setUpdateDropDepot] = useState("");
  const [updateSignAs, setUpdateSignAs] = useState("");
  const [updateSignAsEntity, setUpdateSignAsEntity] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");

  const [addBookingConfirmationDocumentLoader, setAddBookingConfirmationDocumentLoader] = useState(false);
  const [updateBookingConfirmationDocumentLoader, setUpdateBookingConfirmationDocumentLoader] = useState(false);
  const [deleteBookingConfirmationDocumentLoader, setDeleteBookingConfirmationDocumentLoader] = useState(false);
  const [deleteBookingConfirmationDocumentId, setDeleteBookingConfirmationDocumentId] = useState("");
  const [issueBookingConfirmationDocumentLoader, setIssueBookingConfirmationDocumentLoader] = useState(false);
  const [cancelBookingConfirmationDocumentLoader, setCancelBookingConfirmationDocumentLoader] = useState(false);

  const [showPrintBookingConfirmationModal, setShowPrintBookingConfirmationModal] = useState(false);
  const [showPreviewPrintBookingConfirmationModal, setShowPreviewPrintBookingConfirmationModal] = useState(false);
  

  const getShipment = async (shipment_id) => {
    setShipmentDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/booking/' + shipment_id);
      if (response) {
        setShipmentData(response.data)
        const booking_items = response.data?.booking_line_item || [];
        const containers = booking_items.map(item => `${item.container_quantity} x ${item.container_type}`).join(", ");
        setUpdateContainer(containers)
      }
    } catch (err) {
      toast.error("Error in fetching shipment data! Try again.");
    }
    setShipmentDataPending(false)
  }

  const getBookingConfirmationDocument = async (shipment_id) => {
    setBookingConfirmationDocumentDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/bookingdocument?shipment=' + shipment_id);
      if (response) {
        setBookingConfirmationDocumentData(response.data)
      }
    } catch (err) {
      toast.error("Error in fetching shipment document data! Try again.");
    }
    setBookingConfirmationDocumentDataPending(false)
  }

  useEffect(() => {
    getShipment(shipment_id)
    getBookingConfirmationDocument(shipment_id)
  }, [shipment_id]);


  const bookingconfirmationdocumentcolumns = [
    {
      name: 'Document Number',
      selector: row => row.reference_number,
      sortable: true,
    },
    {
      name: 'Document Type',
      selector: row => row.document_type,
      sortable: true,
    },
    {
      name: 'Issued By',
      selector: row => row.issued_by_data?.name ?? "-",
      sortable: true,
    },
    {
      name: 'Issue Date',
      selector: row => row.issue_date ?? "-",
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => <span className={`${row.status=="ISSUED"?"bg-success text-white px-2 rounded":row.status=="CANCELLED"?"bg-danger text-white px-2 rounded":""}`}>{row.status}</span>,
      sortable: true,
    },
    {
      name: 'Action',
      width: '110px',
      center: true,
      selector: row =>
        <div>
          {
            currentUserRolePermissionData?.includes("shipment:bookingconfirmation:update") ?
              <Button className="btn btn-sm btn-inox-green border-0 my-1" style={{ height: 30 }} title="Update" onClick={() => handleShowUpdateBookingConfirmationDocumentModal(row)}>
                <i className="fa fa-edit"></i>
              </Button>
              :
              ""
          }

          {
            currentUserRolePermissionData?.includes("shipment:bookingconfirmation:delete") ?
              <Button className="btn btn-sm btn-danger my-1 mx-1" style={{ height: 30 }} title="Delete" onClick={() => handleDeleteBookingConfirmationDocumentModal(row)}>
                <i className="fa fa-trash"></i>
              </Button>
              :
              ""
          }
        </div>,
    }
  ];

  const handleShowAddBookingConfirmationDocumentModal = () => {
    setShowAddBookingConfirmationDocumentModal(true)
  }

  const handleCloseAddBookingConfirmationDocumentModal = () => {
    setShowAddBookingConfirmationDocumentModal(false)
  }

  const handleShowUpdateBookingConfirmationDocumentModal = async (data) => {
    setShowUpdateBookingConfirmationDocumentModal(true)
    setUpdateBookingConfirmationDocumentId(data.id)
    setUpdateShipment(data?.shipment_data)
    setUpdateDocumentType(data?.document_type)
    setUpdateReferenceNumber(data?.reference_number)
    setUpdateIssuedBy(data?.issued_by_data)
    setUpdateIssueDate(data?.issue_date)
    setUpdateContainer(data?.container)
    setUpdateBookingParty(data?.booking_party)
    setUpdatePickDepot(data?.pick_depot_data)
    setUpdateDropDepot(data?.drop_depot_data)
    setUpdateSignAs(data?.sign_as)
    setUpdateSignAsEntity(data?.signing_entity)
    setUpdateStatus(data?.status)
  }

  const handleUpdateBookingConfirmationDocumentModalClose = () => {
    setShowUpdateBookingConfirmationDocumentModal(false)
    setUpdateBookingConfirmationDocumentId("")
    setUpdateShipment("")
    setUpdateDocumentType("")
    setUpdateReferenceNumber("")
    setUpdateIssuedBy("")
    setUpdateIssueDate("")
    setUpdateBookingParty("")
    setUpdatePickDepot("")
    setUpdateDropDepot("")
    setUpdateSignAs("")
    setUpdateSignAsEntity("")
    setUpdateStatus("")
  }

  const handleDeleteBookingConfirmationDocumentModal = (row) => {
    setShowDeleteBookingConfirmationDocumentModal(true)
    setDeleteBookingConfirmationDocumentId(row.id)
  }

  const addBookingConfirmationDocument = async (e) => {
    e.preventDefault();
    setAddBookingConfirmationDocumentLoader(true)

    const existing_document = bookingConfirmationDocumentData.length
    const new_number = existing_document + 1

    const data = {
      "shipment": shipment_id,
      "reference_number": shipmentData?.reference_number + "_doc_" + new_number,
      "document_type": "BOOKING_CONFIRMATION",
      "container": addconfirmationdocumentform.current.container.value,
      "booking_party": addconfirmationdocumentform.current.booking_party.value,
      "pick_depot": addconfirmationdocumentform.current.pick_depot.value,
      "drop_depot": addconfirmationdocumentform.current.drop_depot.value,
      "sign_as": addconfirmationdocumentform.current.sign_as.value,
      "signing_entity": addconfirmationdocumentform.current.signing_entity.value,
      "created_by": loggedInUser?.id
    }

    try {
      const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL + '/master/bookingdocument/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 201) {
        toast.success("Booking confirmation document generated successfully");
        getBookingConfirmationDocument(shipment_id)
        addconfirmationdocumentform.current.booking_party.value = ""
        addconfirmationdocumentform.current.pick_depot.value = ""
        addconfirmationdocumentform.current.drop_depot.value = ""
        addconfirmationdocumentform.current.sign_as.value = ""
        addconfirmationdocumentform.current.signing_entity.value = ""
      }
    } catch (err) {
      toast.error("Error in generating booking confirmation document! Try again.");
    }

    getBookingConfirmationDocument(shipment_id)
    setAddBookingConfirmationDocumentLoader(false)
    setShowAddBookingConfirmationDocumentModal(false)
  }

  const updateBookingConfirmationDocument = async (e) => {
    e.preventDefault();
    setUpdateBookingConfirmationDocumentLoader(true)

    const id = updateBookingConfirmationDocumentId

    const data = {
      "id": id,
      "shipment": shipment_id,
      "reference_number": shipmentData?.reference_number,
      "document_type": updateDocumentType,
      "container": updateContainer,
      "booking_party": updateBookingParty,
      "pick_depot": updatePickDepot?.id,
      "drop_depot": updateDropDepot?.id,
      "sign_as": updateSignAs,
      "signing_entity": updateSignAsEntity,
      "modified_by": loggedInUser?.id
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/bookingdocument/'+id+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Booking confirmation document updated successfully");
        getBookingConfirmationDocument(shipment_id)
      }
    } catch (err) {
      toast.error("Error in updating document! Try again.");
    }

    getBookingConfirmationDocument(shipment_id)
    setShowUpdateBookingConfirmationDocumentModal(false)
    setUpdateBookingConfirmationDocumentLoader(false)
  }

  const deleteBookingConfirmationDocument = async (e) => {
    e.preventDefault();
    setDeleteBookingConfirmationDocumentLoader(true)

    const id = deleteBookingConfirmationDocumentId

    try {
      const response = await axios.delete(process.env.REACT_APP_BACKEND_API_URL + '/master/bookingdocument/' + id + '/');

      if (response.status == 204) {
        toast.success("Booking confirmation document deleted successfully");
        getBookingConfirmationDocument(shipment_id)
      }
    } catch (err) {
      toast.error("Error in deleting document! Try again.");
    }
    setDeleteBookingConfirmationDocumentLoader(false)
    setShowDeleteBookingConfirmationDocumentModal(false)
  }

  const issueConfirmationDocument = async (e) => {
    e.preventDefault();
    setIssueBookingConfirmationDocumentLoader(true)


    const data = {
      "id": updateBookingConfirmationDocumentId,
      "status": "ISSUED",
      "issue_date": format(new Date(), 'yyyy-MM-dd'),
      "issued_by": loggedInUser?.id,
      "modified_by": loggedInUser?.id
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/bookingdocument/'+updateBookingConfirmationDocumentId+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Document issued successfully");
        getBookingConfirmationDocument(shipment_id)
      }
    } catch (err) {
      toast.error("Error in issuing cro! Try again.");
    }

    getBookingConfirmationDocument(shipment_id)
    setShowIssueBookingConfirmationDocumentModal(false)
    setShowUpdateBookingConfirmationDocumentModal(false)
    setIssueBookingConfirmationDocumentLoader(false)
  }

  const cancelConfirmationDocument = async (e) => {
    e.preventDefault();
    setCancelBookingConfirmationDocumentLoader(true)

    const data = {
      "id": updateBookingConfirmationDocumentId,
      "status": "DRAFT",
      "issue_date": null,
      "modified_by": loggedInUser?.id
    }

    try {
      const response = await axios.put(process.env.REACT_APP_BACKEND_API_URL + '/master/bookingdocument/'+updateBookingConfirmationDocumentId+'/', data, { headers: { "Content-Type": "application/json" } });

      if (response.status == 200) {
        toast.success("Document cancelled successfully");
        getBookingConfirmationDocument(shipment_id)
      }
    } catch (err) {
      toast.error("Error in cancelling cro! Try again.");
    }

    getBookingConfirmationDocument(shipment_id)
    setShowCancelBookingConfirmationDocumentModal(false)
    setShowUpdateBookingConfirmationDocumentModal(false)
    setCancelBookingConfirmationDocumentLoader(false)
  }

  return (
    <div>
      <div className="col-12 text-left" style={{ marginTop: -5 }}>
        <div className="row">
          <div className="col-9">
            {
            currentUserRolePermissionData?.includes("shipment:bookingconfirmation:add") ?
            <Button className="btn btn-inox-green border-0" onClick={() => handleShowAddBookingConfirmationDocumentModal()}>Add Document</Button>
            :
            ""
            }
          </div>
        </div>


        <DataTable
          columns={bookingconfirmationdocumentcolumns}
          data={bookingConfirmationDocumentData}
          progressPending={bookingConfirmationDocumentDataPending}
          progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
          noDataComponent={<p className="text-center table-no-data">No Confirmation Document Found</p>}
          highlightOnHover
          customStyles={userTableCustomStyles}
          dense
        />
      </div>

      <Modal size="xl" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showAddBookingConfirmationDocumentModal} onHide={() => handleCloseAddBookingConfirmationDocumentModal()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Confirmation Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>          
          <form ref={addconfirmationdocumentform}>
            <div className="row">
              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Document Reference Number</label>
                  <div class="col-12">
                    <input type="text" id="reference_number" name="reference_number" className="form-control form-control-sm" disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Booking Number</label>
                  <div class="col-12">
                    <input type="text" id="booking_number" name="booking_number" value={shipmentData?.reference_number} className="form-control form-control-sm" disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Booking Agent</label>
                  <div class="col-12">
                    <input type="text" id="booking_agent" name="booking_agent" value={shipmentData?.booking_agent_data?.name} className="form-control form-control-sm" disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Booking Party</label>
                  <div class="col-12">
                    <textarea rows={2} type="text" id="booking_party" name="booking_party" className="form-control form-control-sm"/>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Containers</label>
                  <div class="col-12">
                    <input type="text" id="container" name="container" className="form-control form-control-sm" value={updateContainer} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Issue Date</label>
                  <div class="col-12">
                    <input type="text" id="issue_date" name="issue_date" className="form-control form-control-sm" disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Cargo Type</label>
                  <div class="col-12">
                    <input type="text" id="cargo_type" name="cargo_type" className="form-control form-control-sm" value={shipmentData?.booking_line_item?.[0]?.cargo_type} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Status</label>
                  <div class="col-12">
                    <input type="text" id="status" name="status" className="form-control form-control-sm" value="DRAFT" disabled/>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">POA</label>
                  <div class="col-12">
                    <input type="text" id="poa" name="poa" className="form-control form-control-sm" value={shipmentData?.poa_data?.name} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">POL</label>
                  <div class="col-12">
                    <input type="text" id="pol" name="pol" className="form-control form-control-sm" value={shipmentData?.pol_data?.name} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">POD</label>
                  <div class="col-12">
                    <input type="text" id="pod" name="pod" className="form-control form-control-sm" value={shipmentData?.pod_data?.name} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">FD</label>
                  <div class="col-12">
                    <input type="text" id="fd" name="fd" className="form-control form-control-sm" value={shipmentData?.fd_data?.name} disabled/>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Pick Depot</label>
                  <div class="col-12">
                    <select name="pick_depot" id="pick_depot" className="form-select form-select-sm">
                      <option value="">Select Depot</option>
                      {depotList.map(depot => (
                        <option value={depot.id}>{depot.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Drop Depot</label>
                  <div class="col-12">
                    <select name="drop_depot" id="drop_depot" className="form-select form-select-sm">
                      <option value="">Select Depot</option>
                      {depotList.map(depot => (
                        <option value={depot.id}>{depot.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Sign As</label>
                  <div class="col-12">
                    <select name="sign_as" id="sign_as" className="form-select form-select-sm">
                      <option value="">Select Sign As</option>
                      <option value="AGENT">AGENT</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Signing Entity</label>
                  <div class="col-12">
                    <select name="signing_entity" id="signing_entity" className="form-select form-select-sm">
                      <option value="">Select entity</option>
                      {agentList.map(agent => (
                        <option value={agent.id}>{agent.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 text-center">
              <Button type="button" className="btn btn-inox-green border-0 mt-3" onClick={(e) => addBookingConfirmationDocument(e)}>
                {addBookingConfirmationDocumentLoader ?
                  <Spinner className="mx-5 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Add Document"
                }
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>


      <Modal size="xl" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showUpdateBookingConfirmationDocumentModal} onHide={() => handleUpdateBookingConfirmationDocumentModalClose()} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-12">
              <div class="dropdown">
                <button type="button" style={{ paddingTop: 7, paddingBottom: 8, float: 'right' }} title="Language" class="btn btn-inox-green border-0 text-white" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span class="d-flex align-items-center">
                    <span className="fa fa-bars"></span>
                  </span>
                </button>

                <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end">
                  {updateStatus!="ISSUED"?
                  <span class="dropdown-item pointer pointer" onClick={() => setShowIssueBookingConfirmationDocumentModal(true)}>
                    <i className="fa fa-check text-success"></i><span className="mx-2">Issue</span>
                  </span>
                  :""}

                  {updateStatus!="CANCELLED"?
                  <span class="dropdown-item pointer pointer" onClick={() => setShowCancelBookingConfirmationDocumentModal(true)}>
                    <i className="fa fa-times text-danger"></i><span className="mx-2">Cancel</span>
                  </span>
                  :""}

                  <span class="dropdown-item pointer pointer" onClick={() => setShowPrintBookingConfirmationModal(true)}>
                    <i className="fa fa-print text-inox-green"></i><span className="mx-2">Print</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <form>
            <div className="row">
              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Document Reference Number</label>
                  <div class="col-12">
                    <input type="text" id="reference_number" name="reference_number" className="form-control form-control-sm" value={updateReferenceNumber} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Booking Number</label>
                  <div class="col-12">
                    <input type="text" id="booking_number" name="booking_number" value={shipmentData?.reference_number} className="form-control form-control-sm" disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Booking Agent</label>
                  <div class="col-12">
                    <input type="text" id="booking_number" name="booking_number" value={shipmentData?.booking_agent_data?.name} className="form-control form-control-sm" disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Booking Party</label>
                  <div class="col-12">
                    <textarea rows={2} type="text" id="booking_number" name="booking_number" className="form-control form-control-sm" value={updateBookingParty} onChange={(e) => setUpdateBookingParty(e.target.value)}/>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Containers</label>
                  <div class="col-12">
                    <input type="text" id="container" name="container" className="form-control form-control-sm" value={updateContainer} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Issue Date</label>
                  <div class="col-12">
                    <input type="text" id="container" name="container" className="form-control form-control-sm" value={updateIssueDate} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Cargo Type</label>
                  <div class="col-12">
                    <input type="text" id="cargo_type" name="cargo_type" className="form-control form-control-sm" value={shipmentData?.booking_line_item?.[0]?.cargo_type?.replaceAll("_"," ")} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Status</label>
                  <div class="col-12">
                    <input type="text" id="status" name="status" className="form-control form-control-sm" value="DRAFT" disabled/>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">POA</label>
                  <div class="col-12">
                    <input type="text" id="poa" name="poa" className="form-control form-control-sm" value={shipmentData?.poa_data?.name} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">POL</label>
                  <div class="col-12">
                    <input type="text" id="pol" name="pol" className="form-control form-control-sm" value={shipmentData?.pol_data?.name} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">POD</label>
                  <div class="col-12">
                    <input type="text" id="pod" name="pod" className="form-control form-control-sm" value={shipmentData?.pod_data?.name} disabled/>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">FD</label>
                  <div class="col-12">
                    <input type="text" id="fd" name="fd" className="form-control form-control-sm" value={shipmentData?.fd_data?.name} disabled/>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Pick Depot</label>
                  <div class="col-12">
                    <select name="pick_depot" id="pick_depot" className="form-select form-select-sm" onChange={(e) => setUpdatePickDepot(e.target.value)}>
                      <option value="">Select Depot</option>
                      {depotList.map(depot => (
                        <option value={depot.id} selected={depot.id=updatePickDepot?.id?true:false}>{depot.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Drop Depot</label>
                  <div class="col-12">
                    <select name="drop_depot" id="drop_depot" className="form-select form-select-sm" onChange={(e) => setUpdateDropDepot(e.target.value)}>
                      <option value="">Select Depot</option>
                      {depotList.map(depot => (
                        <option value={depot.id} selected={depot.id=updateDropDepot?.id?true:false}>{depot.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Sign As</label>
                  <div class="col-12">
                    <select name="sign_as" id="sign_as" className="form-select form-select-sm" onChange={(e) => setUpdateSignAs(e.target.value)}>
                      <option value="">Select Sign As</option>
                      <option value="AGENT" selected={updateSignAs=="AGENT"?true:false}>AGENT</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="col-3">
                <div class="form-group mb-2">
                  <label class="col-12 col-form-label font-12px">Signing Entity</label>
                  <div class="col-12">
                    <select name="signing_entity" id="signing_entity" className="form-select form-select-sm" onChange={(e) => [setUpdateSignAsEntity(e.target.value), console.log(e.target.value)]}>
                      <option value="">Select Entity</option>
                      {agentList.map(agent => (
                        <option value={agent.id} selected={updateSignAsEntity==agent.id?true:false}>{agent.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 text-center">
              <Button className="btn btn-inox-green border-0 mt-3" onClick={(e) => updateBookingConfirmationDocument(e)}>
                {updateBookingConfirmationDocumentLoader ?
                  <Spinner className="mx-5 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Update CRO"
                }
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showDeleteBookingConfirmationDocumentModal} onHide={() => setShowDeleteBookingConfirmationDocumentModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <div className="col-12">
                Do you want to delete this document?
              </div>

              <div className="col-12 text-center mt-4">
                <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={(e) => setShowDeleteBookingConfirmationDocumentModal(false)}>Cancel</Button>

                <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => deleteBookingConfirmationDocument(e)}>
                  {deleteBookingConfirmationDocumentLoader ?
                    <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    :
                    "Delete"
                  }
                </Button>


              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>


      {/*  ---------------------------_PRINT CONFIRMATION DOCUMENT ---------------------------- */}
      <Modal size="xl" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showPrintBookingConfirmationModal} onHide={() => setShowPrintBookingConfirmationModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Print Confirmation Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div id="confirmation_document" className="col-12" style={{ textTransform: 'uppercase', fontSize: '12px', paddingTop: "30px" }}>
              <div className="row">
                <div className="col-2">
                  <img src={logoInoxShipping} class="img-fluid" width="80%"></img>
                </div>
                <div className="col-8 text-center">
                  <h4>INOX SHIPPING AGENCIES (INDIA) PVT LTD</h4>
                  <p className="font-12px">A- WING, OFFICE # 108 & 109 1ST FLOOR, HERMES ATRIUM, SECTOR 11, CBD BELAPUR, NAVI MUMBAI - 400614, MAHARASHTRA, INDIA GST#: 27AAECI6725P1ZZ</p>
                  <p className="font-12px"><b>PHONE:</b> +91 9082813976 | <b>EMAIL:</b> IMPORTS@INOXSHIPPING.COM <b>PAN:</b> AAECI6725P</p>
                </div>
                <div className="col-2">
                  <img src={logoInoxShipping} class="img-fluid float-right" width="80%"></img>
                </div>
              </div>

              <div className="row">
                <p className="border-top border-bottom text-center fw-bold">DRAFT BOOKING CONFIRMATION</p>
              </div>

              <div className="row mx-1">
                <div className="col-6 border py-2">
                  <p className="mb-0">Booking Party</p>
                  <p>{updateBookingParty}</p>
                  <p></p>
                </div>
                  
                <div className="col-3">
                  <div className="row">
                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>Doc Reference Number</b></p>
                      <p className="mb-0 pb-2">{updateReferenceNumber}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>Booking Number</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.reference_number}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>POA</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.poa_data?.name}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>POD</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.pod_data?.name}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>Commodity</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.booking_line_item?.[0]?.commodity_data?.name} ({shipmentData?.booking_line_item?.[0]?.cargo_type})</p>
                    </div>
                  </div>
                </div>
                
               <div className="col-3">
                  <div className="row">
                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>Issue Date</b></p>
                      <p className="mb-0 pb-2">{updateIssueDate ? format(new Date(updateIssueDate), "dd MMMM,yyyy, hh:mm a"): "-"}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>Service Mode</b></p>
                      <p className="mb-0 pb-2">{updateIssueDate ? format(new Date(updateIssueDate), "dd MMMM,yyyy, hh:mm a"): "-"}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>POL</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.pol_data?.name}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>FD</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.fd_data?.name}</p>
                    </div>

                    <div className="col-12 border">
                      <p className="mb-0 pt-2"><b>Booking Agent</b></p>
                      <p className="mb-0 pb-2">{shipmentData?.booking_agent_data?.name}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row border mx-1">
                <div className="col-12 py-2">
                  <p className="text-center mt-2 mb-0"><b>Equipments</b></p>
                  <p className="mb-0 text-center">{updateContainer}</p>
                </div>
              </div>

              <div className="row border mx-1">
                <div className="col-12 py-2">
                  <p className="text-center"><b>Intented Route & Vessel Plan</b></p>
                  <div className="row">
                    <div className="col-2 border text-center">
                      <p className="pt-2 fw-bold">From Port & Terminal</p>
                      <p className="border-top py-2 font-10px">{shipmentData?.pol_data?.name} - {shipmentData?.pol_terminal_data?.name}</p>
                    </div>

                    <div className="col-2 border text-center">
                      <p className="pt-2 fw-bold">To Port & Terminal</p>
                      <p className="border-top py-2 font-10px">{shipmentData?.pod_data?.name} - {shipmentData?.pod_terminal_data?.name}</p>
                    </div>

                    <div className="col-2 border text-center">
                      <p className="pt-2 fw-bold">Vessel & Voyage</p>
                      <p className="border-top py-2 font-10px">{shipmentData?.first_vessel_schedule_data?.vessel_data?.name} - {shipmentData?.first_vessel_schedule_data?.voyage}</p>
                    </div>

                    <div className="col-2 border text-center">
                      <p className="pt-2 fw-bold">ETA</p>
                      <p className="border-top py-2 font-10px">{shipmentData?.vessel_eta? format(new Date(shipmentData?.vessel_eta), "dd/MM/yyyy, hh:mm a"):"-"}</p>
                    </div>

                    <div className="col-2 border text-center">
                      <p className="pt-2 fw-bold">Cut Off</p>
                      <p className="border-top py-2 font-10px">{shipmentData?.vessel_cut_off? format(new Date(shipmentData?.vessel_cut_off), "dd/MM/yyyy, hh:mm a"):"-"}</p>
                    </div>

                    <div className="col-2 border text-center">
                      <p className="pt-2 fw-bold">ETD</p>
                      <p className="border-top py-2 font-10px">{shipmentData?.vessel_etd? format(new Date(shipmentData?.vessel_etd), "dd/MM/yyyy, hh:mm a"):"-"}</p>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="row">
                    <p className="fw-bold text-center mt-2">Pickup & Delivery Itinerary</p>
                    <div className="col-6 py-2 border-top border-right">
                      <p className="text-center">Empty Container Depot</p>
                      <p>-</p>
                    </div>
                    <div className="col-6 py-2 border-top" style={{ borderLeft: "1px solid lightgrey" }}>
                      <p className="text-center">Return Equipment Depot</p>
                      <p>-</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 text-center mt-4">
              <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => setShowPrintBookingConfirmationModal}>Cancel</Button>

              <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={() => downloadPDF("confirmation_document", "doc_"+updateReferenceNumber)}>Print</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/*  --------------------------- ISSUE Confirmation Document --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showIssueBookingConfirmationDocumentModal} onHide={() => setShowIssueBookingConfirmationDocumentModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Issue Confirmation Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <p>Do you want to issue this confirmation document?</p>
              <div className="col-12 text-center mt-4">
                <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => setShowIssueBookingConfirmationDocumentModal(false)}>Cancel</Button>
                <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => issueConfirmationDocument(e)}>
                  {issueBookingConfirmationDocumentLoader ?
                  <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Issue"
                }
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {/*  --------------------------- Cancel Document --------------------------- */}
      <Modal size="md" style={{ background: 'rgba(0, 0, 0, 0.5)' }} show={showCancelBookingConfirmationDocumentModal} onHide={() => setShowCancelBookingConfirmationDocumentModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="row">
              <p>Do you want to cancel this document?</p>
              <div className="col-12 text-center mt-4">
                <Button className="btn btn-secondary btn-sm px-4 border-0 mx-1" onClick={() => setShowCancelBookingConfirmationDocumentModal(false)}>Cancel</Button>
                <Button className="btn btn-inox-green btn-sm px-4 border-0" onClick={(e) => cancelConfirmationDocument(e)}>
                  {cancelBookingConfirmationDocumentLoader ?
                  <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                  :
                  "Cancel"
                }
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default PlannedExportDocuments;
